import React from 'react';
import './PGDashboard.css';

const PGDashboard = ({ data }) => {
  return (
    <div className="pg-dashboard">
      <div className="dashboard-content">
        <div className="welcome-section">
          <h3>Paying Guest Dashboard</h3>
          <p>Welcome to your personal dashboard. This section is currently under development.</p>
        </div>
        
        <div className="coming-soon">
          <div className="coming-soon-icon">🏠</div>
          <h4>Your Personal Space</h4>
          <p>Your allocation details, payment history, and other personalized features will be available here soon.</p>
        </div>
      </div>
    </div>
  );
};

export default PGDashboard;
